import {
  RadioGroup as AriaRadioGroup,
  type RadioGroupProps as AriaRadioGroupProps,
} from "react-aria-components";

/**
 * A radio group is a collection of radio buttons that are logically grouped together.
 * It is used to select one option from a set.
 *
 * @param name - The name of the radio group.
 * @param value - The value of the selected radio button.
 * @param onChange - The function to call when the selected radio button changes.
 * @param children - The radio buttons to display in the group.
 */

export function RadioGroup({
  name,
  value,
  onChange,
  children,
}: AriaRadioGroupProps) {
  return (
    <AriaRadioGroup
      name={name}
      value={value}
      onChange={onChange}
      className="flex w-full flex-col items-start self-stretch"
      aria-label={name}
    >
      {children}
    </AriaRadioGroup>
  );
}
